enum DiagramType {
	mermaid = "Mermaid",
	"plant-uml" = "Plant-uml",
	bpmn = "Bpmn",
}

export default DiagramType;
